import { useEffect, useState } from "react";

import {
    Container,
    ContentWrapper,
    InfoSidebar,
    ProjectContent,
    ImageBlock,
    NavLinks,
    NavLinkItem,
} from "../styles/SingleItemStyle";

import PageLayout from "../components/PageLayout";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";

const SingleItem = () => {
    const { id } = useParams();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch projects data
        axios.get('/projects')
            .then(response => {
                setProjects(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching projects:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    const index = projects.findIndex((project) => project._id === id);

    const prev = index > 0 ? projects[index - 1] : null;
    const next = index < projects.length - 1 ? projects[index + 1] : null;

    return (
        <PageLayout>
            <Container>
                <ContentWrapper>
                    <InfoSidebar>
                        <h2>{projects[index].title}</h2>

                        <h6>{projects[index].location}</h6>

                        <h6>{Array.isArray(projects[index].tags) ? projects[index].tags.join(", ") : ""}</h6>

                        <p> {projects[index].description} </p>
                    </InfoSidebar>
                    <ProjectContent>
                        <ProjectContent>
                            {Array.isArray(projects[index]?.images) ? (
                                projects[index].images.map((imgUrl, imgIndex) => (
                                    <ImageBlock key={imgIndex} src={imgUrl} alt={`Project Image ${imgIndex + 1}`} />
                                ))
                            ) : (
                                <p>No images available</p>
                            )}
                        </ProjectContent>
                    </ProjectContent>
                </ContentWrapper>
                <NavLinks>
                    {prev
                        ? <NavLinkItem as={Link} to={`/architecture/${prev._id}`}>← {prev.title}</NavLinkItem>
                        : <div />
                    }
                    <NavLinkItem as={Link} to="/architecture">Back to Portfolio</NavLinkItem>
                    {next
                        ? <NavLinkItem as={Link} to={`/architecture/${next._id}`}>{next.title} →</NavLinkItem>
                        : <div />
                    }
                </NavLinks>
                <Footer />
            </Container>
        </PageLayout>
    );
}

export default SingleItem;
